import { Alert, AlertTitle, Box, Typography } from "@mui/material";
import { Constants } from "../Constants";
import { useTranslation } from "react-i18next";
import { LanguagesList } from "./LanguagesList";
import { theme } from "../styles/theme";

export const LanguageData: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <Box>
        <Typography variant="h5">
          {t(Constants.translationKeys.language_page_title)}
        </Typography>
        <Typography variant="body3" color={theme.palette.text.secondary}>
          {t(Constants.translationKeys.language_page_subtitle)}
        </Typography>
      </Box>
      <LanguagesList />
      <Alert severity="info" variant="info">
        <AlertTitle variant="info">
          {t(Constants.translationKeys.langauge_alert_title)}
        </AlertTitle>
        {t(Constants.translationKeys.langauge_alert_content)}
      </Alert>
    </Box>
  );
};